const TicketHistory=(props)=>{
    const handleRouteClick = (params) => {
        props.onShowTicketHistory(props);
    };
    return (
        <a onClick={handleRouteClick} title="View Route"><i className="fa fa-history f20"></i> </a>
    );
}
export default TicketHistory